import React, { Fragment, useContext, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, UNSAFE_LocationContext, UNSAFE_NavigationContext } from 'react-router-dom';
import { FloatingPanelManager, GlobalActionsStackManager, GlobalActionsStackProvider, ModalManager, ToastManager } from '@philips-internal/oswald-ui-components';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { ConfigurationService, HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { PreviewRenderer } from '@philips-internal/oswald-ui-editor-core/lib/renderer/index.js';
import { Engine, MetadataStore, ReactRenderer } from '@philips-internal/oswald-ui-engine';
import { bootstrap } from '../../environment/index.js';
import { applicationContext, FoundationApplicationContext, foundationContext } from '../../index.js';
import { FoundationApplication, FoundationLoader } from '../index.js';
function noop() {
    return Promise.resolve();
}
function HistoryServiceInitializer(props) {
    const locationContext = useContext(UNSAFE_LocationContext);
    const navigationContext = useContext(UNSAFE_NavigationContext);
    const [initialized, setInitialized] = useState(false);
    useEffect(() => {
        const location = locationContext.location;
        const history = navigationContext.navigator;
        // @ts-ignore: `react-router` restricts the History type down to some basic functionalities and
        // renames it to navigator, but it still is the full history object.
        HistoryService.initialize({ history, location });
        setInitialized(true);
    }, []);
    if (initialized) {
        return (React.createElement(Fragment, null, props.children));
    }
    return null;
}
function getPreviewServerURL() {
    if (import.meta.env.PROD) {
        return '';
    }
    const port = import.meta.env.OSWALD_PREVIEW_PORT;
    return `ws://localhost:${port}`;
}
async function isPreviewServerRunning() {
    if (import.meta.env.PROD) {
        return false;
    }
    // try-catch block to ensure that even in the event of an invalid URL,
    // there's a fallback to the normal behavior.
    try {
        const url = new URL(getPreviewServerURL());
        return new Promise((resolve) => {
            const socket = new WebSocket(url);
            socket.addEventListener('open', () => resolve(true));
            socket.addEventListener('error', () => resolve(false));
        });
    }
    catch {
        return false;
    }
}
async function getEngine() {
    if (await isPreviewServerRunning()) {
        return new Engine({ metadataStore: new MetadataStore(), renderer: new PreviewRenderer() });
    }
    return new Engine({ metadataStore: new MetadataStore(), renderer: new ReactRenderer() });
}
function Foundation(props) {
    const { bootstrap: customBootstrap = noop, root } = props;
    const fragmentName = root?.fragmentName ?? foundationContext.getRootFragment() ?? 'root';
    const [bootstraping, setBootstraping] = useState(true);
    const [engine, setEngine] = useState(null);
    useEffect(() => {
        const startBootstrap = async () => {
            const engine = await getEngine();
            const options = {
                engine,
                fragment: fragmentName,
            };
            void bootstrap(options)
                .then(() => customBootstrap())
                .then(() => {
                setBootstraping(false);
                setEngine(engine);
            });
        };
        void startBootstrap();
    }, []);
    if (!engine || bootstraping) {
        return React.createElement(FoundationLoader, null);
    }
    const element = (React.createElement(HistoryServiceInitializer, null,
        React.createElement(FoundationApplication, { engine: engine, rootFragmentName: fragmentName })));
    return (React.createElement(ApplicationContext.Context.Provider, { value: applicationContext },
        React.createElement(FoundationApplicationContext.Provider, { value: applicationContext },
            React.createElement(GlobalActionsStackProvider, null,
                React.createElement(BrowserRouter, { basename: ConfigurationService.getBaseURL() },
                    React.createElement(Routes, null,
                        React.createElement(Route, { element: element, path: "*" })),
                    React.createElement("div", { className: "c-application__managers" },
                        React.createElement(FloatingPanelManager, null),
                        React.createElement(ModalManager, { engine: engine }),
                        React.createElement(GlobalActionsStackManager, { engine: engine }),
                        React.createElement(ToastManager, null),
                        React.createElement("div", { className: "c-tooltip-manager" }),
                        React.createElement("div", { className: "c-popover-manager" })))))));
}
export default Foundation;
//# sourceMappingURL=foundation.js.map